import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import helpers from 'src/helpers';

import { ReactComponent as SearchIcon } from 'src/assets/images/search.svg';
import { ReactComponent as SearchCloseIcon } from 'src/assets/images/search-close.svg';
import searchStyle from 'src/components/View/Header/search.style';

function Search({
  classes,
  search,
  setSearch,
  onSearch,
  onClear,
}) {
  const [startSearchTime, setStartSearchTime] = useState(0);

  const handleOnChangeSearch = (event) => {
    const { target } = event || {};
    const { value } = target || {};

    setSearch(value || '');

    if (startSearchTime) {
      clearTimeout(startSearchTime);
    }

    setStartSearchTime(setTimeout(() => {
      onSearch();
    }, 1200));
  };

  const handleOnClear = () => {
    if (!helpers.isEmpty(search)) {
      onClear();
    }
  };

  const handleOnKeyDown = (event) => {
    if (event.key === 'Enter') {
      clearTimeout(startSearchTime);
      onSearch();
    }
  };

  return (
    <div className={`${classes.root} inner`}>
      <div className="icon">
        <SvgIcon
          className="svgIcon"
          component={SearchIcon}
          viewBox="0 0 24 24"
        />
      </div>
      <input
        className="input"
        placeholder="Search"
        value={search}
        onChange={handleOnChangeSearch}
        onKeyDown={handleOnKeyDown}
      />
      <div className="iconRight">
        <button
          type="button"
          className="buttonWithoutStyles"
          onClick={handleOnClear}
        >
          <SvgIcon
            className="svgIcon"
            component={SearchCloseIcon}
            viewBox="0 0 20 20"
          />
        </button>
      </div>
    </div>
  );
}

Search.propTypes = {
  classes: PropTypes.object.isRequired,
  search: PropTypes.string.isRequired,
  setSearch: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};
Search.defaultProps = {};

export default withStyles(Search, searchStyle, { withTheme: true });
